import {
    AnimationBaseController,
    IAnimationControllerConfiguration,
    Inject,
} from '@denishussar/html5-game-engine';
import { GameLogic } from '../../../Logic/GameLogic';
import { AnimationContents } from '../../../../AnimationContents';
import { BonusModel, BonusTypeEnum } from '../../../Models/Game/BonusModel';
import { DBBonusController } from './DBBonusController';

export class BonusController extends AnimationBaseController {
    $model: BonusModel;

    public constructor(
        @Inject private _options,
        @Inject private _gameLogic: GameLogic
    ) {
        super('BonusController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.GAME_SCREEN_JSON,
            libraryName: 'bonus_container',
            childControllers: {
                DBController: {
                    view: DBBonusController,
                    model: this.$model,
                },
            },
            modelWatch: {
                pos: (pos: [number, number]) => {
                    this.x = pos[0];
                    this.y = pos[1];
                },
                type: (type: BonusTypeEnum) => {
                    this.setType(
                        this.$model.visible && this.$model.active
                            ? this.$model.type
                            : BonusTypeEnum.none
                    );
                },
                active: (value: boolean) => {
                    this.setType(
                        this.$model.visible && this.$model.active
                            ? this.$model.type
                            : BonusTypeEnum.none
                    );
                },
                visible: (value: boolean) => {
                    this.setType(
                        this.$model.visible && this.$model.active
                            ? this.$model.type
                            : BonusTypeEnum.none
                    );
                },
                isCatch: (value: boolean) => {
                    if (value) {
                        this.gotoAndStopByQuery('bonus', BonusTypeEnum.none);
                        this.$queue.get('catch').addToQueue();
                    }
                },
            },
            queue: {
                catch: {
                    condition: clock => clock >= 0.5,
                    action: () => {
                        this.$model.visible = false;
                        this.$model.active = false;
                    },
                },
            },
        };
    }

    protected onInitialize(): void {
        this.setType(BonusTypeEnum.none);
    }

    protected onUpdate(frameRate: number) {
        const global = this.display.parent.toGlobal(
            new PIXI.Point(this.display.x, this.display.y)
        );

        this._gameLogic.setBonusScreenPosition(
            this.$model.type,
            this.$model.roomIndex,
            [global.x, global.y]
        );
    }

    private setType(type: BonusTypeEnum): void {
        this.gotoAndStopByQuery('bonus', type);
        this.getCurrentPointsPaths((x, y, paths, shapeContainer, shape) => {
            shapeContainer.visible = false;
        }, 'bonus');

        this.$childControllers.get('DBController').visible =
            type !== BonusTypeEnum.none;
    }
}
